// Copyright (c) StrangeBee 2024

import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';

export const ErrorContent = ({ data, base }: CardContentProps): ReactElement => {
    const { objectType } = base;

    return (
        <StreamCard title={`[${objectType}] error`} base={base}>
            <h3>Data</h3>
            <pre>{JSON.stringify(data, null, 2)}</pre>
            <h3>Base</h3>
            <pre>{JSON.stringify(base, null, 2)}</pre>
        </StreamCard>
    );
};
